import { memo, useMemo, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { arrayMove, sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc';
import { BzButton, BzInputText, } from '../../../components';




const ManageColumns = ({
    deleteCustomisableColumns,
    handleCheckBox,
    handleAddingColumnsToCustomisable,
    strModalNameViewType,
    arrAllColoumns,
    arrFixedColumns,
    customizeColoumns,
    setArrManageGridCustomizeColoumns,
    objViewWiseColumnProfiles,
    columnViewType,
    userColumnProfiles,
    existsInarrFixedColumnsArray,
    setIsDisableBtnInSort,
    ...props }) => {




    const DragHandle = sortableHandle(({columnName}) => <div data-testid={`manage-columns-drag-${columnName}`} className='icon-14 icon-rearrange icon-secondary ms-2'></div>); {/* Hari P: icone change */ }

    const SortableItem = useMemo(() => sortableElement(({ column }) => (
        <Row className='your-columns-list g-0 mb-1 px-2 py-2 sortable-item'>
            <Col>
                <div data-testid={`manage-columns-customisable-${column?.sColumnName?.toUpperCase()}`} className='font-medium font-size2 color-text justify-content-start align-items-center'>{column?.sColumnName?.toUpperCase()}</div>
            </Col>
            <Col md={2} className='d-flex justify-content-end align-items-center'>
                <div className='d-flex justify-content-end'>
                    <div data-testid={`manage-columns-deletecolumn-${column?.sColumnName?.toUpperCase()}-btn`} className='icon-14 icon-delete icon-secondary' onClick={(e) => deleteCustomisableColumns(e, column)} />
                    <DragHandle columnName={column?.sColumnName?.toUpperCase()}/>
                </div>
            </Col>
        </Row>
    )), [deleteCustomisableColumns]);

    const SortableContainer = useMemo(() => sortableContainer(({ children }) => {
        return <ul className='list-group'>{children}</ul>;
    }), []);


    const [strMangeColumnsSearchText, setManageColumnsSearchText] = useState('');
    const [toggle, setToggle] = useState(null);
    const isSameOrder = (fixedArray, modifiedArray) => {
        const ischanged = JSON.stringify(fixedArray) === JSON.stringify(modifiedArray);
        setIsDisableBtnInSort(!ischanged);
    };
    const onSortEnd = ({ oldIndex, newIndex, ...rest }) => {
        setArrManageGridCustomizeColoumns(items => {
            const newColumns = arrayMove(items, oldIndex, newIndex);
            //Here need to check the customised columns are in same order or not
            let abc = userColumnProfiles?.filter((eachProfile) => eachProfile?.sViewType === columnViewType);
            //if user has no column prfoiles this iwll help to add defautl columns to custmisable columns
            if (abc?.length > 0) {
                let selectedProfileColumns = abc[0]?.columnDetails;
                // filteredColumns contains the coulumns which are with initial index to compare with columnprofile
                const filteredColumns = selectedProfileColumns?.filter((obj) => !existsInarrFixedColumnsArray(obj));
                //nSequenceNo
                const oldColumnIndex = filteredColumns[newIndex];
                isSameOrder(filteredColumns, newColumns);
            } else { }
            return newColumns;
        });
    };




    return (
        <form onSubmit={(e) => e?.preventDefault()}>
            <Container fluid className='p-0'>
                <Row className='g-0 pt-3'>
                    <Col md={6} className='pe-2'>
                        <div data-testid={`manage-column-subtitle-${strModalNameViewType}`} className='font-regular font-size4 color-text mb-3'>Add columns to your {strModalNameViewType}</div>
                        <div className='position-relative'>
                            <div className='icon-14 icon-search icon-dark search-icon-position'></div>
                            <BzInputText data-testid="manage-column-search-input" size='sm' placeholder='Search for columns' type='search' className='p-l-30 font-regular scripname-searchtext' value={strMangeColumnsSearchText} onChange={(e) => setManageColumnsSearchText(e?.target?.value)} />
                        </div>

                        <div className='all-columns-wrapper p-2'>
                            <div className='flex-column'>
                                <div className='all-columns-list'>
                                    {arrAllColoumns?.length > 0 &&
                                        arrAllColoumns?.filter((eachColumn) => eachColumn?.sColumnName?.toLowerCase()?.includes(strMangeColumnsSearchText?.toLowerCase()))?.map((item, index) =>
                                            <div key={index} className='list-group-item py-2'>
                                                <Row className='g-0'>
                                                    <Col className='d-flex justify-content-between align-items-center'>
                                                        <div className='d-flex justify-content-start align-items-center'>
                                                            {item?.data?.length && <div className='icon-10 icon-arrowdown icon-grey' onClick={() => toggle == index ? setToggle(null) : setToggle(index)}>&nbsp;</div>}
                                                            <div data-testid={`manage-columns-newcolumns-${item?.sColumnName?.toUpperCase()}`} className='font-regular font-size3 color-text me-2 mx-1'>{item?.sColumnName?.toUpperCase()}</div>
                                                        </div>
                                                        <div className='btn-tabfocus'>
                                                            <BzButton className='btn btn-sm'>
                                                                <div data-testid={`manage-columns-addtocustomise-${item?.sColumnName?.toUpperCase()}`} className='icon-16 icon-forward-arrow icon-secondary' onClick={(e) => handleAddingColumnsToCustomisable(e, item)}></div>
                                                            </BzButton>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className='g-0'>
                                                    {toggle === index &&
                                                        <Col className='bdr-btm pb-2 mb-3 mf-filter-scroll'>
                                                            {item?.data?.map((subItem, index) => {
                                                                return <Row key={index} className='g-0 form-check'>
                                                                    <Col className='d-flex justify-content-between align-items-center pt-2 pb-1'>
                                                                        <div className='d-flex justify-content-start align-items-center form-check-label font-regular font-size2 color-subtext ps-2'>{subItem?.sColumnName}</div>
                                                                        <input className='form-check-input' type="checkbox" name={subItem} value={subItem} onChange={(e) => handleCheckBox(e, subItem)}
                                                                            checked={customizeColoumns?.some(element => element?.sColumnName?.toLowerCase() === subItem?.sColumnName?.toLowerCase()) ? true : false} />
                                                                    </Col>
                                                                </Row>;
                                                            })}
                                                        </Col>
                                                    }
                                                </Row>
                                                <Row className='g-0'>
                                                    {toggle === index &&
                                                        <Col className='bdr-btm pb-2 mb-3 mf-filter-scroll'>
                                                            {item?.data?.map((subItem, index) => {
                                                                return <Row key={index} className='g-0 form-check'>
                                                                    <Col className='d-flex justify-content-between align-items-center pt-2 pb-1'>
                                                                        <div className='d-flex justify-content-start align-items-center form-check-label font-regular font-size2 color-subtext ps-2'>{subItem?.sColumnName}</div>
                                                                        <input className='form-check-input' type="checkbox" name={subItem} value={subItem} onChange={(e) => handleCheckBox(e, subItem)}
                                                                            checked={customizeColoumns?.some(element => element?.sColumnName?.toLowerCase() === subItem?.sColumnName?.toLowerCase()) ? true : false} />
                                                                    </Col>
                                                                </Row>;
                                                            })}
                                                        </Col>
                                                    }
                                                </Row>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </Col>
                    <Col md={6} className='your-columns-wrapper p-3'>
                        <div className='font-regular font-size4 color-text mb-2'>Your {strModalNameViewType} Columns</div>
                        <div className='p-2 background-light'>
                            <div className='list-wrapper-main'>
                                <div className='list-wrapper p-2'>
                                    <div className='font-medium font-size2 color-text pt-1 mb-2'>Fixed View</div>
                                    <div>
                                        {
                                            arrFixedColumns?.length > 0 && arrFixedColumns?.map((column, i) =>
                                                <div key={i} className='your-columns-list mb-1 px-2 py-2'>
                                                    <div data-testid={`manage-columns-fixedview-${column.sColumnName?.toUpperCase()}`} className='font-medium font-size2 color-text'>{column.sColumnName?.toUpperCase()}</div>
                                                </div>
                                            )
                                        }
                                    </div>

                                    <div className='list-wrapper'>
                                        <div className='font-medium font-size2 color-secondary pt-4 mb-2'>Customizable View</div>
                                        <SortableContainer axis="y" helperClass='sortable-list-tab' lockAxis="y" distance={0} useDragHandle onSortEnd={onSortEnd} >
                                            {
                                                customizeColoumns?.length > 0 && customizeColoumns?.map((column, i) =>
                                                    <SortableItem key={`item-${i}`} className='your-columns-list' index={i} column={column} />
                                                )
                                            }
                                        </SortableContainer>
                                    </div>
                                </div>
                            </div>
                        </div>



                    </Col>
                </Row>

                {/* <Row className='g-0 pt-3'> // this code should be uncommented in second phase of breeze -Ameersha N
                    <Col className='d-flex justify-content-start align-items-center cursor-pointer'>
                        <div className='icon-12 icon-add background-textual-link-withicon me-2'></div>
                        <div className='font-medium font-size2 color-textual-link-withicon p-t-2'>Create Custom Column</div>
                    </Col>
                </Row> */}

            </Container>
        </form>
    );
};

export default memo(ManageColumns);